"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useAddressSearch = require("../../hooks/questionnaire/useAddressSearch");
var _services = require("../../services");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FormWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
    gap: 8px;
  `)}
`;
const RowWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
    gap: 8px;
    flex-direction: row;
  `)}
`;
const ColumnWrapper = _styledComponents.default.div`
  display: flex;
  flex: 1;
  ${_ref => {
  let {
    maxWidth
  } = _ref;
  return maxWidth && _r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      max-width: ${maxWidth};
    `);
}}
  & label span{
      font-size: 16px;
      line-height: 24px;
      ${_r10SourceLibrary.Mixins.respondTo.md(`font-size: 18px; line-height: 27px;`)}
  }
  & div[class*='StateTextstyle__StateTextContainer']{
      line-height: 21px;
  }      
`;
const StyledErrorParagraph = _styledComponents.default.p`

  font-size: 18px;
  line-height: 22.5px;
  ${_r10SourceLibrary.Mixins.respondTo.md(`font-size: 20px; line-height: 25px;`)}
  font-weight: 700;
`;
const renderErrorNotification = () => /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
  spacingLevel: {
    bottom: 2
  }
}, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.StateNotification, {
  state: "error",
  id: "address-input-error"
}, /*#__PURE__*/_react.default.createElement(StyledErrorParagraph, null, _services.locale.localeString('Questionnaire.AddressSelectorNoBroadbandAvailable'))));
const QuestionWithAddressInputFields = _ref2 => {
  let {
    question,
    selections
  } = _ref2;
  const [blurConditions, setBlurConditions] = (0, _react.useState)({});
  let {
    address,
    streetNumber,
    streetName,
    onStreetNumberChange,
    onStreetNameChange,
    onChange,
    isAddressNoFoundError,
    isCheckAvailabilityLoading,
    setIsInvalidInputRule
  } = (0, _useAddressSearch.useAddressSearch)(question, selections, true);
  const onBlur = inputName => {
    setBlurConditions({
      ...blurConditions,
      [inputName]: true
    });
  };
  const handleStateError = function (key, value, maxLength, translationKey) {
    var _Object$values$find;
    let specialCharsRegex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : /[?=()"§/"$/%]/;
    const rules = {
      empty: {
        state: !value && !!blurConditions[key],
        message: _services.locale.localeString('Questionnaire.AddressSelectorValidationErrorMessage', {
          value: _services.locale.localeString(`Questionnaire.${translationKey}`)
        })
      },
      maxLength: {
        state: value.length > maxLength,
        message: _services.locale.localeString('Questionnaire.AddressSelectorMaxLengthErrorMessage', {
          value: _services.locale.localeString(`Questionnaire.${translationKey}`)
        })
      },
      specialChars: {
        state: specialCharsRegex.test(value),
        message: _services.locale.localeString('Questionnaire.AddressSelectorSpecialCharsErrorMessage', {
          value: _services.locale.localeString(`Questionnaire.${translationKey}`)
        })
      }
    };
    return (_Object$values$find = Object.values(rules).find(rule => rule.state)) !== null && _Object$values$find !== void 0 ? _Object$values$find : {};
  };

  //regex to prevent using special characters in city or postcode field except for () character.
  const cityOrPostcodeRegex = /[?="§/"$/%]/;
  const addressErrorState = handleStateError('address', address, 50, 'AddressSelectorPlaceholder', cityOrPostcodeRegex);
  const streetNameErrorState = handleStateError('streetName', streetName, 50, 'streetNamePlaceholder');
  const streetNumberErrorState = handleStateError('streetNumber', streetNumber, 10, 'streetNumberPlaceholder');
  (0, _react.useEffect)(() => {
    setIsInvalidInputRule(!!(addressErrorState.state || streetNameErrorState.state || streetNumberErrorState.state));
  }, [addressErrorState, streetNameErrorState, streetNumberErrorState]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAddressNoFoundError && !isCheckAvailabilityLoading && renderErrorNotification(), /*#__PURE__*/_react.default.createElement(FormWrapper, null, /*#__PURE__*/_react.default.createElement(RowWrapper, null, /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    maxWidth: '100%'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: addressErrorState.state && 'error',
    fieldWrapper: {
      label: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#fff'
        }
      }, _services.locale.localeString('Questionnaire.AddressSelectorPlaceholder')),
      stateText: addressErrorState.message,
      width: 'full'
    },
    textInput: {
      type: 'text',
      id: 'address-search',
      maxLength: 51,
      value: address,
      autoComplete: 'address-line1',
      onChange: e => {
        onChange(e.target.value);
      },
      onBlur: () => onBlur('address')
    }
  }))), /*#__PURE__*/_react.default.createElement(RowWrapper, null, /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    maxWidth: "66%"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: streetNameErrorState.state && 'error',
    fieldWrapper: {
      label: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#fff'
        }
      }, _services.locale.localeString('Questionnaire.streetNamePlaceholder')),
      width: 'full',
      stateText: streetNameErrorState.message,
      validateOn: 'blur'
    },
    textInput: {
      required: true,
      type: 'text',
      maxLength: 51,
      id: 'address-street-name',
      value: streetName,
      autoComplete: 'street-address',
      onChange: e => onStreetNameChange(e.target.value),
      onBlur: () => onBlur('streetName')
    }
  })), /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    maxWidth: "34%"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: streetNumberErrorState.state && 'error',
    fieldWrapper: {
      label: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#fff'
        }
      }, _services.locale.localeString('Questionnaire.streetNumberPlaceholder')),
      stateText: streetNumberErrorState.message,
      validateOn: 'blur',
      width: 'full'
    },
    textInput: {
      type: 'text',
      id: 'address-street-number',
      autoComplete: 'off',
      maxLength: 11,
      value: streetNumber,
      onChange: e => onStreetNumberChange(e.target.value),
      onBlur: () => onBlur('streetNumber')
    }
  })))), isCheckAvailabilityLoading && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: _services.locale.localeString('Questionnaire.CheckLoaderText'),
    size: 1,
    appearance: "secondary"
  }));
};
var _default = QuestionWithAddressInputFields;
exports.default = _default;